/** Gap between frames, and the length of the flash each one plays. */
export const GOAL_DATE_TICK_STEP_MS = 750

const DAY_MS = 86_400_000
const MAX_TICK_FRAMES = 12
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

function toIsoDate(ms: number): string {
  return new Date(ms).toISOString().slice(0, 10)
}

function toUtcMs(iso: string): number | null {
  if (!ISO_DATE.test(iso)) return null
  const ms = Date.parse(`${iso}T00:00:00.000Z`)
  if (!Number.isFinite(ms)) return null
  return toIsoDate(ms) === iso ? ms : null
}

/**
 * Countdown frames for the faster-progress date, one per day shaved off the
 * plain goal date.
 *
 * @param goalDateIso un-shaved goal date, `YYYY-MM-DD`
 * @param fasterDateIso faster-progress date, `YYYY-MM-DD`
 * @returns `[goalDateIso, …, fasterDateIso]`. `[]` when either date is
 *   unparseable, they are equal or inverted, or the gap exceeds
 *   `MAX_TICK_FRAMES` days.
 */
export function buildGoalDateTickFrames(
  goalDateIso: string | null | undefined,
  fasterDateIso: string | null | undefined,
): string[] {
  const from = toUtcMs(goalDateIso ?? '')
  const to = toUtcMs(fasterDateIso ?? '')
  if (from === null || to === null) return []

  const days = Math.round((from - to) / DAY_MS)
  if (days < 1 || days > MAX_TICK_FRAMES) return []

  const frames: string[] = []
  for (let i = 0; i <= days; i++) frames.push(toIsoDate(from - i * DAY_MS))
  return frames
}
